import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email"]
  static values = { redirectUrl: String }

  connect() {
    this.modalViewed = false
    this.emailStarted = false

    this.capture("waitlist_modal_viewed")
  }

  backdropClick(event) {
    if (event.target !== this.element) return
    this.dismiss()
  }

  dismiss() {
    this.capture("waitlist_modal_dismissed")
    const url = this.redirectUrlValue || "/"
    window.location.assign(url)
  }

  emailInput(event) {
    if (this.emailStarted) return

    const value = event?.target?.value?.trim()
    if (!value) return

    this.emailStarted = true
    this.capture("waitlist_modal_email_started")
  }

  capture(event, properties = {}) {
    if (typeof window === "undefined") return
    if (!window.posthog || typeof window.posthog.capture !== "function") return

    window.posthog.capture(event, properties)
  }
}
